import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["className", "gutter", "size"];
import clsx from 'clsx';
import { useTheme } from '@emotion/react';
import { jsx as ___EmotionJSX } from "@emotion/react";

const BlockGrid = _ref => {
  let {
    className,
    gutter = {
      base: 'base'
    },
    size = {}
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const theme = useTheme();

  const percentWidth = columnSize => {
    const calc = 100 / columnSize;
    return `${calc}%`;
  };

  const gutterCalc = gutterSize => [gutter[gutterSize] && {
    [theme.mq[gutterSize]]: {
      margin: `${gutter[gutterSize] === 'collapse' ? 0 : -theme.space[gutter[gutterSize]]}px 0 0 ${gutter[gutterSize] === 'collapse' ? 0 : -theme.space[gutter[gutterSize]]}px`,
      '> .CK__ListItem': {
        paddingLeft: gutter[gutterSize] === 'collapse' ? 0 : theme.space[gutter[gutterSize]],
        paddingTop: gutter[gutterSize] === 'collapse' ? 0 : theme.space[gutter[gutterSize]]
      }
    }
  }];

  return ___EmotionJSX("ul", _extends({
    css: ["display:flex;flex:0 1 auto;flex-flow:row wrap;padding:0;list-style:none;> .CK__ListItem{flex:0 0 100%;max-width:100%;}", gutter.base && {
      margin: `${gutter.base === 'collapse' ? 0 : -theme.space[gutter.base]}px 0 0 ${gutter.base === 'collapse' ? 0 : -theme.space[gutter.base]}px`,
      '> .CK__ListItem': {
        paddingLeft: gutter.base === 'collapse' ? 0 : theme.space[gutter.base],
        paddingTop: gutter.base === 'collapse' ? 0 : theme.space[gutter.base]
      }
    }, gutterCalc('small'), gutterCalc('medium'), gutterCalc('large'), gutterCalc('xlarge'), //
    // Size
    //
    size.base && {
      '> .CK__ListItem': {
        flexBasis: percentWidth(size.base),
        maxWidth: percentWidth(size.base)
      }
    }, size.small && {
      [theme.mq.small]: {
        '> .CK__ListItem': {
          flexBasis: percentWidth(size.small),
          maxWidth: percentWidth(size.small)
        }
      }
    }, size.medium && {
      [theme.mq.medium]: {
        '> .CK__ListItem': {
          flexBasis: percentWidth(size.medium),
          maxWidth: percentWidth(size.medium)
        }
      }
    }, size.large && {
      [theme.mq.large]: {
        '> .CK__ListItem': {
          flexBasis: percentWidth(size.large),
          maxWidth: percentWidth(size.large)
        }
      }
    }, size.xlarge && {
      [theme.mq.xlarge]: {
        '> .CK__ListItem': {
          flexBasis: percentWidth(size.xlarge),
          maxWidth: percentWidth(size.xlarge)
        }
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:BlockGrid;"],
    className: clsx('CK__BlockGrid', className)
  }, rest));
};

export default BlockGrid;